import PageHeader from "@/components/PageHeader";
import PlansGrid from "@/components/sections/PlansGrid";
import DomainSearch from "@/components/sections/DomainSearch";
import SEO from "@/components/SEO";

export default function HostingPage() {
  return (
    <main data-testid="hosting-page">
      <SEO
        title="Web Hosting Plans — Managed, Fast, Secure | LaneX Labs"
        description="Managed web hosting engineered for performance and reliability. Free SSL, automated backups, CDN acceleration and 24/7 monitoring. Plans from £5 per month."
        path="/hosting"
      />
      <PageHeader
        overline="Hosting"
        title={<>Hosting that actually<br /><em className="italic text-gradient">performs</em>.</>}
        lead="Managed hosting on enterprise-grade infrastructure. Free SSL, automated backups, CDN, monitoring — set up and maintained by our team."
      />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-6 -mt-6">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-9">
            <p className="text-[15px] text-[color:var(--text-muted)] leading-relaxed">
              Every hosting plan is fully managed. Our engineers handle server configuration, TLS
              certificate renewal, DNS, WAF and DDoS protection, application-level caching and daily
              backups so you never think about ops. Sites on our hosting typically achieve sub-second
              time-to-interactive on 4G, WCAG 2.2 accessibility passes, and 99.99% uptime SLAs on
              Business plans. Combine with a new or transferred domain and business email in a single
              basket — one invoice, one team.
            </p>
          </div>
        </div>
      </section>

      <PlansGrid kind="hosting" cta="Choose plan" />

      <DomainSearch />
    </main>
  );
}
